import { render, staticRenderFns } from "./ProductReinsurance.vue?vue&type=template&id=c23b4566&"
import script from "./ProductReinsurance.vue?vue&type=script&lang=ts&"
export * from "./ProductReinsurance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports